import { ServiceExecutionModel } from 'app/app-model/diagnostic-service/service-execution.model';

export class ServiceExecutionSequenceModel {
  id: number;
  categoryItemId: number;
  executions: Array<ServiceExecutionModel> = [];
}
